/* eslint-disable jsx-a11y/label-has-associated-control */
import { CommonInput, ImageInput } from '../../../../../components/widgets';

import strings from '../../../../../localization';

const Profile = ({
  data, register, watch, onActiveChange,
}) => {
  const [logo] = [watch('logo')];

  return (
    <>
      <form>
        <h4>Temel Bilgiler</h4>
        <section className={`grid grid-${data ? '4' : '3'}`}>
          <CommonInput
            label="Organizatör Adı"
            placeholder="eg: Sunset Events"
            register={register('name', { required: true })}
            defaultValue={data?.name}
          />
          <CommonInput
            label="Organizatör Telefonu"
            placeholder="eg: +90 216 000 0000"
            register={register('phone', { required: true })}
            defaultValue={data?.phone}
          />
          <CommonInput
            label="Organizatör E-Maili"
            placeholder="eg: info@organizer.com"
            register={register('email', { required: true })}
            defaultValue={data?.email}
          />
          {data && (
            <div className="mb-0 d-flex flex-column justify-content-end">
              <label>Mekan aktif mi?</label>
              <button
                type="button"
                onClick={onActiveChange}
                className={`w-100 btn btn-${data?.active ? 'success' : 'danger'}`}
              >
                {data?.active ? 'Evet' : 'Hayır'}
              </button>
            </div>
          )}
        </section>
        <h4 className="mb-0 mt-2">Organizatör Logosu</h4>
        <ImageInput
          register={register('logo', { required: true })}
          defaultValue={data?.logo}
          watch={logo}
          placeholder="1024x1024 veya 1:1 oranda logo"
          label="Organizatör Logosu"
        />
      </form>
      <form>
        <h4 className="mb-0 mt-2"> Sosyal Medya Hesapları</h4>
        <section className="grid grid-4">
          <CommonInput
            label={strings['commons-social-instagram']}
            register={register('socials.instagram')}
            placeholder="eg: instagram.com/username"
            defaultValue={data?.socials?.instagram}
            append={(<i className="fa fa-instagram mr" />)}
          />
          <CommonInput
            label={strings['commons-social-twitter']}
            register={register('socials.twitter')}
            defaultValue={data?.socials?.twitter}
            placeholder="eg: twitter.com/username"
            append={(<i className="fa fa-twitter mr" />)}
          />
          <CommonInput
            label={strings['commons-social-facebook']}
            register={register('socials.facebook')}
            defaultValue={data?.socials?.facebook}
            placeholder="eg: facebook.com/username"
            append={(<i className="fa fa-facebook mr" />)}
          />
          <CommonInput
            label={strings['commons-social-website']}
            register={register('socials.website')}
            defaultValue={data?.socials?.website}
            placeholder="eg: organizer.com"
            append={(<i className="fa fa-globe mr" />)}
          />
        </section>
        <h4 className="mb-0 mt-2">Açıklamalar</h4>
        <section className="grid grid-2">
          <CommonInput
            label="Türkçe Açıklama"
            register={register('desc.tr', { required: true })}
            defaultValue={data?.desc?.tr}
            placeholder="Lütfen kısa bir açıklama yazınız."
            multiline
            multilineHeight={15}
          />
          <CommonInput
            label="İngilizce Açıklama"
            register={register('desc.en')}
            defaultValue={data?.desc?.en}
            placeholder="Please write a brief description."
            multiline
            multilineHeight={15}
          />
        </section>
      </form>
    </>
  );
};

export default Profile;
